import { getPhoneCodeByTimezone } from 'timezone-phone-codes';
import ct from 'countries-and-timezones';

const getTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

// interaktif.tech: müşterilerimizin tamamı Türkiye'de — saat diliminden ülke
// çözülemezse (Windows "Turkey", "Asia/Istanbul" vb.) form "ülke kodu seçin"
// diye takılıyordu (2026-08-17 site sohbeti). Varsayılan +90 / TR.
export const getActiveDialCode = () => {
  return getPhoneCodeByTimezone(getTimezone()) || '+90';
};

export const getActiveCountryCode = () => {
  const country = ct.getCountryForTimezone(getTimezone()) || {};
  return country.id || 'TR';
};
